import Resource from './Resource';

export default class StudentDataForms extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {}
		} = options;

		let route = `data-verification-forms/:setting`;

		let config = {
			route: route,
			routeParams: routeParams,
			query: query,
			data: data,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	put() {
		return this.request('put');
	}

	post() {
		return this.request('post');
	}

	delete() {
		return this.request('delete');
	}
}
